import { lazy, Suspense, memo } from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "../styles/Loader.css"; // Import external CSS, no inline

// Lazy-loaded pages
const Home = lazy(() => import("../pages/Home"));
const About = lazy(() => import("../pages/About"));
const BusListing = lazy(() => import("../pages/BusListing"));
const BusDetails = lazy(() => import("../pages/BusDetails"));
const Blog = lazy(() => import("../pages/Blog"));
const BlogDetails = lazy(() => import("../pages/BlogDetails"));
const Contact = lazy(() => import("../pages/Contact"));
const NotFound = lazy(() => import("../pages/NotFound"));

// External CSS fallback component
const FallbackLoader = () => <div className="loader-fallback"></div>;

const Routers = () => {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://dubairentaltour.com" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Suspense fallback={<FallbackLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/buses" element={<BusListing />} />
          <Route path="/buses/:slug" element={<BusDetails />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/:slug" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default memo(Routers);
